/**
 * Canonical responsive breakpoints for the web app.
 * Tailwind `theme.screens` in tailwind.config.js must match these values.
 * Plan: .specify/planning/responsive-breakpoints-alignment.md
 */
export const SCREENS = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
} as const;

/** Numeric px values for hooks (window.innerWidth comparisons). */
export const SCREENS_PX = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const;

/**
 * max-width companions (min-width − 1px). Use for "below md" etc. so rules do not
 * overlap Tailwind `md:` / styled `min-width: ${SCREENS.md}` at the exact breakpoint.
 */
export const SCREENS_MAX = {
  sm: '639px',
  md: '767px',
  lg: '1023px',
  xl: '1279px',
  '2xl': '1535px',
} as const;

export type ScreenKey = keyof typeof SCREENS;
